export default "__VITE_ASSET__yInaNxTe__"